<!--
 * @description: 首页 轮播图内容
 * @Author: Jay
 * @Date: 2021-09-23 15:17:17
 * @LastEditors: Jay
 * @LastEditTime: 2021-10-19 15:44:49
-->
<template>
  <div>
    <div class="flex flex-center justify-between">
      <div class="padding-xl">
        <div
          class="text-grey font_size_df animate__animated animate__fadeInUp"
          v-show="tabIndex == index"
        >
          <!-- 英语标题 -->
          <div class="text-grey font_size_df">
            <!-- {{ item.engName }} -->
            <!-- {{ type }} -->
          </div>
          <!-- 中文标题-->
          <div class="text-blue font_weight_bold font_size_xl margin-top-xs">
            {{ item.goods_name }}
          </div>
          <!-- 符号 -->
          <!-- <div class="text-gray margin-top iconHover">
            <p>
              <span class="cuIcon-more"></span>
              <span class="cuIcon-more"></span>
              <span class="cuIcon-more"></span>
            </p>
            <p>
              <span class="cuIcon-more"></span>
              <span class="cuIcon-more"></span>
              <span class="cuIcon-more"></span>
            </p>
            <p>
              <span class="cuIcon-more"></span>
              <span class="cuIcon-more"></span>
              <span class="cuIcon-more"></span>
            </p>
          </div> -->
          <!-- 内容介绍 -->
          <div class="margin-top font_size_df txt-detail html-img">
            <!-- <p v-html="item.content"></p> -->
            <p v-html="item.title_content"></p>
          </div>
          <!-- 查看更多 -->
          <div class="margin-top-xl" @click="skipTap">
            <span class="text-paleblue"> 查看更多</span>
            <div class="line-more margin-top-xs"></div>
          </div>
        </div>
      </div>
      <el-image class="sample-img" :src="$api + item.images" />
    </div>
  </div>
</template>

<script>
export default {
  props: ["item", "tabIndex", "index", "type", "title"],
  data() {
    return {
      isFixed: false,
    };
  },
  mounted() {},
  methods: {
    //查看更多
    skipTap() {
      // console.log(this.title);
      switch (this.title) {
        case "自然博物馆":
          this.goTo({ path: "/NatureCoupe" });
          break;
        case "科普巡展":
          this.goTo({ path: "/Roadshow" });
          break;
        case "科普文创":
          this.goTo({ path: "/Cultural" });
          break;
        case "互动体验":
          this.goTo({ path: "/Interactive" });
          break;
        // default:
        //   break;
      }
    },
    //集体跳转
    goTo(url) {
      this.$router.push(url);
    },
  },
  destroyed() {},
};
</script>

<style lang="scss" scoped>
//轮播图 内容 图片
.sample-img {
  width: 780px;
  height: 480px;
}

//   内容介绍
.txt-detail {
  width: 498px;
  color: #666666;
  line-height: 32px;
  display: -webkit-box;
  display: -moz-box;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
}

//查看更多
.line-more {
  width: 55px;
  height: 2px;
  background-color: #54bad4;
}
//   .line-more:hover {
//     width: 11px;
//     text-align: center;
//     height: 2px;
//     background-color: #54bad4;
//   }

.iconHover:hover {
  color: #519cf3;
}

// v-html 样式
.html-img {
  ::v-deep {
    img {
      max-width: 100%;
    }
  }
}
</style>
